import "babel-polyfill"
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Routes.js';
import store from './store.js';

ReactDOM.render(
  <Root />,
  document.getElementById('root')
);

export default store;



// WEBPACK FOOTER //
// ./src/index.js